import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { animate, sequence, state, style, transition, trigger } from '@angular/animations';
import { BreadcrumbEntry, BreadcrumbService } from '../../../shared/services/breadcrumb.service';

@Component({
  selector: 'vpfe-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      state('in', style({ opacity: 1, display: 'block' })),
      state('out', style({ opacity: 0, display: 'none' })),
      transition('in => out', [
        sequence([
          style({ opacity: 1 }),
          animate('0.15s ease-in-out', style({ opacity: 0 })),
          style({ opacity: 0, display: 'none' }),
        ]),
      ]),
      transition('out => in', [
        sequence([
          style({ display: 'block', position: 'absolute' }),
          animate('0.15s ease-in-out', style({ position: 'relative' })),
          animate('0.15s ease-in-out', style({ opacity: 1, display: 'block' })),
          style({ opacity: 1 }),
        ]),
      ]),
    ]),
  ],
})
export class BreadcrumbComponent {
  private breadcrumbService = inject(BreadcrumbService);
  public breadcrumbs$ = this.breadcrumbService.breadcrumbs$;

  public trackByFn(index: number, item: BreadcrumbEntry) {
    return item.label;
  }
}
